/**
 * Nozl Theme — Premium Mouth Tape Brand
 * Complete Shopify theme JavaScript
 * Vanilla JS IIFE, no dependencies
 */
(function () {
  'use strict';

  /* ----- Currency State (global within IIFE) ----- */
  // Store base currency is AED. Rate: 1 GBP ≈ 4.7 AED
  var AED_TO_GBP = 1 / 4.7; // ≈ 0.2128
  var currentCurrency = 'GBP'; // default display currency

  /**
   * PRICE CORRECTION: Shopify admin has prices stored as AED 0.63 / 0.68
   * instead of the intended AED 63.65 / 68.55. Rather than requiring the user
   * to update every variant in Shopify admin, we apply a ×100 correction here.
   * This multiplier is applied when tagging price elements from Shopify output.
   * Set to 1 if/when admin prices are corrected.
   */
  var PRICE_CORRECTION_MULTIPLIER = 100;

  /* ----- Loading Screen ----- */
  (function initLoadingScreen() {
    var screen = document.getElementById('loading-screen');
    if (!screen) return;

    function hideLoader() {
      screen.classList.add('is-hidden');
      setTimeout(function() {
        if (screen.parentNode) screen.parentNode.removeChild(screen);
      }, 700);
    }

    // Hide after animation completes (1.8s) or on window load, whichever comes last
    var barDone = false;
    var pageLoaded = false;

    setTimeout(function() {
      barDone = true;
      if (pageLoaded) hideLoader();
    }, 1000);

    window.addEventListener('load', function() {
      pageLoaded = true;
      if (barDone) hideLoader();
    });

    // Failsafe: always hide after 1.8s
    setTimeout(hideLoader, 1800);
  })();

  /* ========================================================================
   * UTILITIES
   * ======================================================================== */

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.from((scope || document).querySelectorAll(selector));
  }

  function on(el, event, handler, opts) {
    if (el) el.addEventListener(event, handler, opts || false);
  }

  function delegate(parent, eventType, selector, handler) {
    if (!parent) return;
    on(parent, eventType, function (e) {
      var target = e.target.closest(selector);
      if (target && parent.contains(target)) {
        handler.call(target, e, target);
      }
    });
  }

  function formatMoney(cents) {
    // Shopify returns cents in store base currency (AED)
    // Apply correction: admin prices are 100x too low, so multiply cents by 100
    var aedAmount = (cents / 100) * PRICE_CORRECTION_MULTIPLIER;
    if (currentCurrency === 'AED') {
      return 'Dhs. ' + aedAmount.toFixed(2);
    }
    // Convert AED to GBP
    var gbpAmount = aedAmount * AED_TO_GBP;
    return '\u00A3' + gbpAmount.toFixed(2);
  }

  function formatPrice(amount, currency) {
    if (currency === 'GBP') {
      return '\u00A3' + amount.toFixed(2);
    }
    return 'Dhs. ' + amount.toFixed(2);
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ========================================================================
   * 1. SCROLL ANIMATIONS (Intersection Observer)
   * ======================================================================== */

  function initScrollAnimations() {
    var elements = qsa('.fade-in-up, .fade-in');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;

        if (el.classList.contains('stagger-children')) {
          Array.from(el.children).forEach(function (child, i) {
            child.style.transitionDelay = (i * 0.1) + 's';
            child.classList.add('visible');
          });
        }

        el.classList.add('visible');
        observer.unobserve(el);
      });
    }, { threshold: 0.1 });

    elements.forEach(function (el) { observer.observe(el); });

    qsa('.stagger-children').forEach(function (el) {
      if (!el.classList.contains('fade-in-up') && !el.classList.contains('fade-in')) {
        observer.observe(el);
      }
    });
  }

  /* ========================================================================
   * 2. STICKY HEADER
   * ======================================================================== */

  function initStickyHeader() {
    var header = qs('[data-header]');
    if (!header) return;

    var threshold = 50;

    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ========================================================================
   * 3. MOBILE MENU
   * ======================================================================== */

  function initMobileMenu() {
    var toggle = qs('[data-menu-toggle]');
    if (!toggle) return;

    function openMenu() {
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    }

    on(toggle, 'click', function (e) {
      e.preventDefault();
      if (document.body.classList.contains('menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close on overlay click
    delegate(document, 'click', '[data-nav-overlay]', function () {
      closeMenu();
    });

    // Close on nav link click (works for both desktop and mobile nav)
    delegate(document, 'click', '[data-nav] a, .header__nav a, .mobile-nav__link', function () {
      closeMenu();
    });

    // Close on Escape
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
        closeMenu();
      }
    });
  }

  /* ========================================================================
   * 4. PRODUCT IMAGE CAROUSEL
   * ======================================================================== */

  function initProductImageCarousel() {
    var mainImage = qs('[data-product-main-image]');
    var thumbnails = qsa('[data-thumb-index]');
    if (!mainImage || !thumbnails.length) return;

    var currentIndex = 0;

    thumbnails.forEach(function (thumb, idx) {
      on(thumb, 'click', function () {
        var img = thumb.querySelector('img');
        var src = thumb.dataset.src || (img ? img.src : '');
        if (!src) return;

        if (mainImage.tagName === 'IMG') {
          mainImage.src = src;
        } else {
          var mainImg = mainImage.querySelector('img');
          if (mainImg) mainImg.src = src;
        }

        thumbnails.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        currentIndex = idx;
      });
    });

    // Touch swipe support
    var touchStartX = 0;

    on(mainImage, 'touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    on(mainImage, 'touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < thumbnails.length - 1) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }
        thumbnails[currentIndex].click();
      }
    }, { passive: true });
  }

  /* ========================================================================
   * 5. VARIANT SELECTOR
   * ======================================================================== */

  function initVariantSelector() {
    var pills = qsa('.variant-pill');
    if (!pills.length) return;

    var priceDisplay = qs('.homepage-product__price-amount');
    var hiddenInput = qs('[data-variant-input]');
    var atcBtn = qs('[data-add-to-cart]');

    // Tag each pill with its AED base from the data-variant-price attribute
    pills.forEach(function (pill) {
      var rawPrice = pill.dataset.variantPrice || pill.textContent;
      var numVal = extractPriceNumber(rawPrice);
      if (numVal > 0) {
        // Shopify renders data-variant-price in AED money format "Dhs. XX.XX"
        // Apply correction multiplier (admin prices are 100x too low)
        if (isAedFormat(rawPrice)) {
          pill.dataset.aed = (numVal * PRICE_CORRECTION_MULTIPLIER).toFixed(2);
        } else {
          // If somehow showing GBP already, reverse and correct
          pill.dataset.aed = (numVal * 4.7 * PRICE_CORRECTION_MULTIPLIER).toFixed(2);
        }
      }
    });

    pills.forEach(function (pill) {
      on(pill, 'click', function (e) {
        e.preventDefault();

        pills.forEach(function (p) { p.classList.remove('variant-pill--active'); });
        pill.classList.add('variant-pill--active');

        var variantId = pill.dataset.variantId || pill.dataset.id;
        var aedBase = parseFloat(pill.dataset.aed);

        if (hiddenInput && variantId) {
          hiddenInput.value = variantId;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (priceDisplay && !isNaN(aedBase)) {
          priceDisplay.textContent = formatAedAs(aedBase, currentCurrency);
          priceDisplay.dataset.aed = aedBase.toFixed(2);
        }

        // Update Add to Cart button price
        if (atcBtn && !isNaN(aedBase)) {
          atcBtn.textContent = 'Add to Cart \u2014 ' + formatAedAs(aedBase, currentCurrency);
          atcBtn.dataset.aed = aedBase.toFixed(2);
        }
      });
    });
  }

  /* ========================================================================
   * 6. AJAX ADD TO CART
   * ======================================================================== */

  function initAjaxAddToCart() {
    var forms = qsa('[data-product-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();

        var submitBtn = qs('[type="submit"]', form);
        if (!submitBtn || submitBtn.disabled) return;

        var originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          submitBtn.textContent = 'Added!';
          submitBtn.classList.add('btn--success');
          updateCartCount();
          openCartDrawer();

          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            submitBtn.classList.remove('btn--success');
          }, 2000);
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          submitBtn.textContent = 'Error — Try Again';
          submitBtn.classList.add('btn--error');

          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            submitBtn.classList.remove('btn--error');
          }, 2000);
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (counter) {
          counter.textContent = cart.item_count;
          counter.classList.toggle('has-items', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  /* ========================================================================
   * 7. QUANTITY SELECTOR
   * ======================================================================== */

  function initQuantitySelector() {
    delegate(document, 'click', '[data-quantity-minus]', function (e) {
      e.preventDefault();
      var wrapper = this.closest('[data-quantity-selector]') || this.parentElement;
      var input = qs('[data-quantity-input]', wrapper);
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var current = parseInt(input.value, 10) || min;
      input.value = Math.max(min, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    delegate(document, 'click', '[data-quantity-plus]', function (e) {
      e.preventDefault();
      var wrapper = this.closest('[data-quantity-selector]') || this.parentElement;
      var input = qs('[data-quantity-input]', wrapper);
      if (!input) return;
      var max = parseInt(input.max, 10) || 99;
      var current = parseInt(input.value, 10) || 1;
      input.value = Math.min(max, current + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ========================================================================
   * 8. CART DRAWER
   * ======================================================================== */

  var cartDrawer = null;
  var cartDrawerOverlay = null;

  function initCartDrawer() {
    cartDrawer = qs('[data-cart-drawer]');
    cartDrawerOverlay = qs('[data-cart-drawer-overlay]');

    if (!cartDrawer) {
      createCartDrawer();
    }

    delegate(document, 'click', '[data-cart-toggle]', function (e) {
      e.preventDefault();
      openCartDrawer();
    });

    delegate(document, 'click', '[data-cart-drawer-close]', function (e) {
      e.preventDefault();
      closeCartDrawer();
    });

    if (cartDrawerOverlay) {
      on(cartDrawerOverlay, 'click', closeCartDrawer);
    }

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // Quantity buttons inside drawer
    delegate(document, 'click', '[data-cart-drawer] [data-action="minus"]', function (e) {
      e.preventDefault();
      var key = this.dataset.lineKey;
      var qtyEl = this.parentElement.querySelector('[data-qty-value]');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      updateCartItem(key, Math.max(0, current - 1));
    });

    delegate(document, 'click', '[data-cart-drawer] [data-action="plus"]', function (e) {
      e.preventDefault();
      var key = this.dataset.lineKey;
      var qtyEl = this.parentElement.querySelector('[data-qty-value]');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      updateCartItem(key, current + 1);
    });

    delegate(document, 'click', '[data-remove-item]', function (e) {
      e.preventDefault();
      var key = this.dataset.lineKey || this.closest('[data-line-key]').dataset.lineKey;
      updateCartItem(key, 0);
    });
  }

  function createCartDrawer() {
    cartDrawerOverlay = document.createElement('div');
    cartDrawerOverlay.className = 'cart-drawer-overlay';
    cartDrawerOverlay.setAttribute('data-cart-drawer-overlay', '');
    document.body.appendChild(cartDrawerOverlay);
    on(cartDrawerOverlay, 'click', closeCartDrawer);

    cartDrawer = document.createElement('div');
    cartDrawer.className = 'cart-drawer';
    cartDrawer.setAttribute('data-cart-drawer', '');
    cartDrawer.innerHTML =
      '<div class="cart-drawer__header">' +
        '<h3 class="cart-drawer__title">Your Cart</h3>' +
        '<button class="cart-drawer__close" data-cart-drawer-close aria-label="Close cart">&times;</button>' +
      '</div>' +
      '<div class="cart-drawer__body" data-cart-drawer-body></div>' +
      '<div class="cart-drawer__footer" data-cart-drawer-footer></div>';
    document.body.appendChild(cartDrawer);
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('is-open');
    if (!document.body.classList.contains('menu-open')) {
      document.body.style.overflow = '';
    }
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var body = qs('[data-cart-drawer-body]', cartDrawer);
        var footer = qs('[data-cart-drawer-footer]', cartDrawer);
        if (!body || !footer) return;

        if (cart.items.length === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
          footer.innerHTML = '';
          return;
        }

        body.innerHTML = cart.items.map(function (item) {
          return (
            '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
              '<div class="cart-drawer__item-image">' +
                '<img src="' + (item.image || '') + '" alt="' + item.title + '" loading="lazy">' +
              '</div>' +
              '<div class="cart-drawer__item-details">' +
                '<p class="cart-drawer__item-title">' + item.title + '</p>' +
                (item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
                '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
                '<div class="cart-drawer__qty">' +
                  '<button class="cart-drawer__qty-btn" data-action="minus" data-line-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="cart-drawer__qty-value" data-qty-value>' + item.quantity + '</span>' +
                  '<button class="cart-drawer__qty-btn" data-action="plus" data-line-key="' + item.key + '" aria-label="Increase quantity">&plus;</button>' +
                '</div>' +
              '</div>' +
              '<button class="cart-drawer__remove" data-remove-item data-line-key="' + item.key + '" aria-label="Remove item">&times;</button>' +
            '</div>'
          );
        }).join('');

        footer.innerHTML =
          '<div class="cart-drawer__subtotal">' +
            '<span>Subtotal</span>' +
            '<span class="cart-drawer__total-amount" data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<a href="/checkout" class="cart-drawer__checkout-btn">Checkout</a>';

        // Store AED base prices from cart JSON (source of truth — AED cents)
        setTimeout(function() {
          var cartItems = qsa('.cart-drawer__item', cartDrawer);
          cartItems.forEach(function(itemEl, idx) {
            if (idx < cart.items.length) {
              var priceEl = qs('.cart-drawer__item-price', itemEl);
              if (priceEl) {
                priceEl.dataset.aed = (cart.items[idx].final_line_price / 100).toFixed(2);
              }
            }
          });
          var subtotalEl = qs('[data-cart-subtotal]', cartDrawer);
          if (subtotalEl) {
            subtotalEl.dataset.aed = (cart.total_price / 100).toFixed(2);
          }
        }, 50);
      })
      .catch(function (err) {
        console.error('Failed to fetch cart:', err);
      });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      renderCartDrawer();
      updateCartCount();
    })
    .catch(function (err) {
      console.error('Cart update error:', err);
    });
  }

  /* ========================================================================
   * 9. STICKY ADD TO CART BAR
   * ======================================================================== */

  function initStickyAddToCartBar() {
    var stickyBar = qs('[data-sticky-atc]');
    var mainForm = qs('[data-product-form]');
    if (!stickyBar || !mainForm) return;

    var mainBtn = qs('[type="submit"]', mainForm);
    if (!mainBtn) return;

    var stickyBtn = qs('button', stickyBar);
    if (stickyBtn) {
      on(stickyBtn, 'click', function () {
        mainBtn.click();
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);
  }

  /* ========================================================================
   * 10. FAQ ACCORDION
   * ======================================================================== */

  function initFaqAccordion() {
    var triggers = qsa('[data-accordion-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      on(trigger, 'click', function () {
        var parent = trigger.closest('[data-accordion-item]');
        if (!parent) return;

        var content = qs('[data-accordion-content]', parent);
        if (!content) return;

        var isOpen = parent.classList.contains('is-active');

        // Close all others
        triggers.forEach(function (t) {
          var p = t.closest('[data-accordion-item]');
          if (p && p !== parent) {
            p.classList.remove('is-active');
            var c = qs('[data-accordion-content]', p);
            if (c) c.style.maxHeight = null;
            var icon = qs('[data-accordion-icon]', p);
            if (icon) icon.textContent = '+';
            t.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        var icon = qs('[data-accordion-icon]', parent);
        if (isOpen) {
          parent.classList.remove('is-active');
          content.style.maxHeight = null;
          if (icon) icon.textContent = '+';
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          parent.classList.add('is-active');
          content.style.maxHeight = content.scrollHeight + 'px';
          if (icon) icon.textContent = '\u2212';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ========================================================================
   * 11. PRODUCT TABS
   * ======================================================================== */

  function initProductTabs() {
    var tabs = qsa('[data-tab]');
    var panels = qsa('[data-tab-panel]');
    if (!tabs.length || !panels.length) return;

    function activateTab(id) {
      tabs.forEach(function (t) { t.classList.remove('product-tab-btn--active'); });
      panels.forEach(function (p) { p.classList.remove('product-tab-panel--active'); });

      tabs.forEach(function (t) {
        if (t.dataset.tab === id) t.classList.add('product-tab-btn--active');
      });
      panels.forEach(function (p) {
        if (p.dataset.tabPanel === id) p.classList.add('product-tab-panel--active');
      });
    }

    tabs.forEach(function (tab) {
      on(tab, 'click', function (e) {
        e.preventDefault();
        var id = tab.dataset.tab;
        if (id) activateTab(id);
      });
    });

    // Activate first tab by default
    if (tabs[0] && tabs[0].dataset.tab) {
      activateTab(tabs[0].dataset.tab);
    }
  }

  /* ========================================================================
   * 12. SOCIAL PROOF TICKER
   * ======================================================================== */

  function initSocialProofTicker() {
    qsa('[data-ticker]').forEach(function (ticker) {
      var children = Array.from(ticker.children);
      if (!children.length) return;

      // Clone children for seamless loop
      children.forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        ticker.appendChild(clone);
      });

      on(ticker, 'mouseenter', function () {
        ticker.style.animationPlayState = 'paused';
      });

      on(ticker, 'mouseleave', function () {
        ticker.style.animationPlayState = 'running';
      });
    });
  }

  /* ========================================================================
   * 13. NEWSLETTER FORM
   * ======================================================================== */

  function initNewsletterForm() {
    var forms = qsa('[data-newsletter-form]');

    forms.forEach(function (form) {
      var isSubmitting = false;

      on(form, 'submit', function (e) {
        e.preventDefault();
        if (isSubmitting) return;

        var emailInput = qs('input[type="email"]', form);
        if (!emailInput) return;

        var email = emailInput.value.trim();
        var msgEl = qs('[data-newsletter-message]', form);

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showFormMessage(form, msgEl, 'Please enter a valid email address.', 'error');
          return;
        }

        isSubmitting = true;
        var submitBtn = qs('[type="submit"]', form);
        if (submitBtn) submitBtn.disabled = true;

        fetch(form.action || '', { method: 'POST', body: new FormData(form) })
          .then(function (res) {
            if (!res.ok && res.status !== 302 && res.status !== 303) throw new Error();
            showFormMessage(form, msgEl, 'Thank you for subscribing!', 'success');
            emailInput.value = '';
          })
          .catch(function () {
            showFormMessage(form, msgEl, 'Something went wrong. Please try again.', 'error');
          })
          .finally(function () {
            isSubmitting = false;
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  }

  function showFormMessage(form, el, message, type) {
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-newsletter-message', '');
      form.appendChild(el);
    }
    el.textContent = message;
    el.className = 'newsletter-message newsletter-message--' + type;
    el.style.display = 'block';
    setTimeout(function () { el.style.display = 'none'; }, 5000);
  }

  /* ========================================================================
   * 14. SMART CHAT WIDGET
   * ======================================================================== */

  function initChatWidget() {
    var widget = qs('[data-chat-widget]');
    if (!widget) return;

    var toggleBtn = qs('[data-chat-toggle]');
    var closeBtn = qs('[data-chat-close]');
    var panel = qs('[data-chat-panel]');
    var messagesArea = qs('[data-chat-messages]');
    var input = qs('[data-chat-input]');
    var chatForm = qs('[data-chat-form]');

    if (!panel || !messagesArea || !input) return;

    var hasOpened = false;

    /* ----- Chat Knowledge Base ----- */

    var responses = [
      /* ORDERING & SHIPPING — most specific first */
      {
        match: function (t) { return /where.*(order|package|parcel)|track(ing)?|order\s*status/.test(t); },
        reply: "You can track your order using the tracking link in your confirmation email. UK orders typically arrive within 7\u201314 business days, UAE orders within 10\u201318 business days. If you haven\u2019t received tracking info, email us at hello@nozl.store and we\u2019ll look into it straight away."
      },
      {
        match: function (t) { return /free\s*ship|shipping\s*cost|how\s*much.*ship|delivery\s*cost/.test(t); },
        reply: "We ship to the UK and UAE. Shipping costs are calculated at checkout based on your location. UK orders arrive in 7\u201314 business days, UAE orders in 10\u201318 business days."
      },
      {
        match: function (t) { return /international|ship\s*abroad|outside\s*(the\s*)?uk|overseas/.test(t); },
        reply: "We currently ship primarily within the UK with free standard delivery. International shipping is available at checkout \u2014 delivery times and costs vary by destination."
      },
      {
        match: function (t) { return /how\s*long|shipping\s*time|deliver|when\s*will|dispatch|despatc/.test(t); },
        reply: "We offer free standard shipping across the UK which takes 3\u20135 business days. You\u2019ll receive a tracking email once dispatched. International delivery times vary by location."
      },

      /* PRODUCT INFO */
      {
        match: function (t) { return /how/.test(t) && /(use|apply|work|put\s*on|wear|stick)/.test(t); },
        reply: "It\u2019s simple: 1) Make sure your lips are clean and dry. 2) Peel one strip from the pack. 3) Place it horizontally across your lips. 4) Sleep as normal \u2014 your body breathes through your nose. 5) Gently peel from one corner in the morning. Most people feel the difference from night one."
      },
      {
        match: function (t) { return /ingredient|material|made\s*(of|from|with)|what'?s\s*in|composition|fabric/.test(t); },
        reply: "Nozl is made from medical-grade woven fabric with a hypoallergenic, latex-free acrylic adhesive. It\u2019s free from latex, parabens, BPA, and phthalates. Dermatologist tested and suitable for all skin types."
      },
      {
        match: function (t) { return /variant|standard|comfort|hole|which\s*one|difference\s*(between)?|compare|version/.test(t); },
        reply: "We offer two variants: Standard has full lip coverage for maximum benefit. Comfort Fit has a small breathing hole \u2014 perfect if you\u2019re new to mouth taping or want extra reassurance. Both use the same medical-grade adhesive. Check the product section for live pricing in your currency."
      },
      {
        match: function (t) { return /price|cost|how\s*much|expensive|cheap|afford|value/.test(t); },
        reply: "Each Nozl pack contains 30 strips \u2014 a full month of better sleep. Check the product section above for live pricing in your selected currency (GBP or AED). It works out to less than 50p per night!"
      },
      {
        match: function (t) { return /what\s*(is|does|are)|tell\s*me\s*about|explain|about\s*nozl|what\s*do\s*you\s*sell/.test(t); },
        reply: "Nozl is a premium mouth tape designed to gently keep your lips sealed while you sleep, encouraging nasal breathing. This leads to deeper sleep, reduced snoring, and better oxygen intake. Each pack contains 30 strips \u2014 one month of better sleep."
      },

      /* SAFETY & HEALTH */
      {
        match: function (t) { return /children|kids|child|toddler|baby|infant|teenager/.test(t); },
        reply: "Nozl is designed for adults aged 18 and over. We do not recommend mouth taping for children. If you\u2019re concerned about a child\u2019s breathing during sleep, please consult a healthcare professional."
      },
      {
        match: function (t) { return /sleep\s*apn|apn[eo]a|medical|doctor|cpap|diagnos/.test(t); },
        reply: "Nozl is a wellness product, not a medical device. If you have diagnosed sleep apnoea or a medical condition affecting your breathing, please consult your doctor before using mouth tape. We always recommend speaking with a healthcare professional if you have concerns."
      },
      {
        match: function (t) { return /congest|blocked\s*nose|stuffy|cold|flu|sinus/.test(t); },
        reply: "If you have severe nasal congestion, we recommend waiting until it clears. For mild congestion, try a saline rinse before bed. Many people find nasal breathing actually helps open passages over time. Our Comfort Fit variant is ideal during transition periods."
      },
      {
        match: function (t) { return /breath|can'?t\s*breath|suffoca|panic|chok|airway|scary/.test(t); },
        reply: "The tape is designed to be gentle enough that your mouth will open naturally if you need to breathe through it \u2014 it\u2019s not an industrial seal. If you\u2019re concerned, our Comfort Fit variant has a built-in breathing hole for extra reassurance. Your nose provides all the airflow you need."
      },
      {
        match: function (t) { return /allerg|sensitive\s*skin|react|irritat|rash|red(ness)?|itch/.test(t); },
        reply: "Our adhesive is hypoallergenic, latex-free, and free from parabens, BPA, and phthalates. It\u2019s dermatologist tested and designed for sensitive skin. The tape removes pain-free with no residue or redness."
      },
      {
        match: function (t) { return /safe|dangerous|risk|harm|side\s*effect/.test(t); },
        reply: "Absolutely safe. Nozl uses medical-grade, hypoallergenic adhesive that\u2019s been dermatologist tested. The tape holds gently \u2014 you can easily open your mouth or remove it at any time during the night. Thousands of people worldwide use mouth tape safely every night."
      },
      {
        match: function (t) { return /sleep(ing)?\s*position|side\s*sleep|stomach|back\s*sleep|face\s*down/.test(t); },
        reply: "Nozl works in all sleeping positions \u2014 back, side, or stomach. The adhesive stays in place throughout the night regardless of how you sleep."
      },

      /* RETURNS & REFUNDS */
      {
        match: function (t) { return /cancel|cancel\s*order/.test(t); },
        reply: "If you need to cancel an order, email hello@nozl.store as soon as possible. If it hasn\u2019t shipped yet, we can cancel it. Once dispatched, refunds are only available for completely unopened and sealed products within 30 days."
      },
      {
        match: function (t) { return /exchange|wrong\s*(one|item|product|variant)|swap/.test(t); },
        reply: "We don\u2019t offer exchanges or returns on opened products. If you\u2019d like a different variant, please place a new order. If your product arrived damaged, email hello@nozl.store with a photo and we\u2019ll sort it out."
      },
      {
        match: function (t) { return /return|refund|money\s*back|guarantee|not\s*happy|dissatisf/.test(t); },
        reply: "We offer a 30-day money-back guarantee on completely unopened and sealed products only. No returns, no exchanges, and no refunds on opened items \u2014 no exceptions. To request a refund on an unopened product, email hello@nozl.store with your order number and a photo."
      },

      /* RESULTS */
      {
        match: function (t) { return /snor(e|ing)/.test(t); },
        reply: "Mouth taping is one of the most effective ways to reduce snoring. When your mouth stays closed, the airway vibration that causes snoring drops dramatically. Most of our customers report a significant reduction in snoring from night one."
      },
      {
        match: function (t) { return /dry\s*mouth|wake.*dry|cotton\s*mouth|thirst/.test(t); },
        reply: "Mouth breathing during sleep is the primary cause of waking up with a dry mouth. By keeping your mouth gently closed, Nozl maintains your mouth\u2019s natural moisture levels. Most people notice this benefit immediately."
      },
      {
        match: function (t) { return /result|notice|difference|how\s*long.*(work|take|before)/.test(t); },
        reply: "Most customers notice a difference from the very first night \u2014 less dry mouth, reduced snoring, and feeling more rested. The benefits compound over time as nasal breathing becomes your body\u2019s default. Give it at least a week for the full effect."
      },
      {
        match: function (t) { return /benefit|why\s*(should|would)|advantage|worth/.test(t); },
        reply: "Nasal breathing during sleep has many benefits: reduced snoring, less dry mouth, deeper sleep, better oxygen absorption, improved dental health, and more energy during the day. Nozl makes it easy to get all of these benefits from night one."
      },

      /* GREETINGS & GENERAL */
      {
        match: function (t) { return /^(hi|hello|hey|hiya|morning|evening|afternoon|yo|sup|howdy|g'?day)\b/.test(t); },
        reply: "Hey there! \uD83D\uDC4B How can I help you today? I can answer questions about our products, shipping, returns, or anything else."
      },
      {
        match: function (t) { return /^(thank|thanks|cheers|ta|appreciate|thx|ty)\b/.test(t); },
        reply: "You\u2019re welcome! Is there anything else I can help with?"
      },
      {
        match: function (t) { return /^(bye|goodbye|see\s*ya|later|night|good\s*night)\b/.test(t); },
        reply: "Thanks for chatting! If you need anything else, we\u2019re here 24/7. Sleep well! \uD83D\uDE34"
      },
      {
        match: function (t) { return /human|real\s*person|speak\s*to\s*(someone|a\s*person)|agent|customer\s*service|support\s*team|live\s*chat/.test(t); },
        reply: "I\u2019m an automated assistant, but our team is always available at hello@nozl.store. They typically respond within 24 hours. For urgent queries, drop us a DM on Instagram @nozl."
      },

      /* MISC CATCH-ALLS */
      {
        match: function (t) { return /subscription|subscri|auto.*(ship|order)|recurring/.test(t); },
        reply: "We don\u2019t currently offer subscriptions, but many customers stock up with multi-pack purchases. Each pack lasts a full month (30 strips). Keep an eye on our site for future subscription options!"
      },
      {
        match: function (t) { return /discount|coupon|code|promo|offer|sale|deal/.test(t); },
        reply: "Sign up for our newsletter to be the first to hear about special offers and discounts. We regularly run promotions \u2014 follow us on Instagram @nozl to stay in the loop!"
      },
      {
        match: function (t) { return /wholesale|bulk|resell|stock|retail|b2b/.test(t); },
        reply: "For wholesale or bulk enquiries, please email hello@nozl.store with details about your business and estimated quantities. We\u2019d love to work with you!"
      },
      {
        match: function (t) { return /beard|facial\s*hair|moustache|stubble/.test(t); },
        reply: "Nozl works well with facial hair. The medical-grade adhesive is designed to stick effectively across lips regardless of surrounding facial hair. For very thick beards, ensure the tape makes full contact with your lip skin."
      },
      {
        match: function (t) { return /reuse|reusable|wash|one\s*time|single\s*use|disposable/.test(t); },
        reply: "Each Nozl strip is designed for single use to ensure maximum hygiene and adhesion. One pack contains 30 individually sealed strips \u2014 a full month\u2019s supply."
      },
      {
        match: function (t) { return /fall\s*off|stay\s*on|stick|adhesive|peel|come\s*off|unstick/.test(t); },
        reply: "Nozl uses a medical-grade acrylic adhesive that stays secure throughout the night. Make sure your lips are clean and dry before applying for the best hold. The tape removes easily in the morning with a gentle peel from one corner."
      },
      {
        match: function (t) { return /store|shop|stockist|where\s*(to\s*)?buy|retail|amazon/.test(t); },
        reply: "You can purchase Nozl directly from our website at nozl.store. We\u2019re also looking into retail partnerships \u2014 sign up for our newsletter to stay updated!"
      }
    ];

    var FALLBACK_REPLY = "I\u2019m not sure I have the answer to that specific question, but I\u2019d love to help! You can email our team at hello@nozl.store and they\u2019ll get back to you within 24 hours. Or try asking me about our products, shipping, returns, or how to use Nozl.";

    /* ----- Helpers ----- */

    function appendMessage(sender, text) {
      var msg = document.createElement('div');
      msg.className = 'chat-widget__message chat-widget__message--' + sender;
      msg.textContent = text;
      messagesArea.appendChild(msg);
      messagesArea.scrollTop = messagesArea.scrollHeight;
    }

    function showTypingThenReply(text) {
      var typing = document.createElement('div');
      typing.className = 'chat-widget__typing-indicator';
      typing.innerHTML =
        '<div class="chat-widget__message chat-widget__message--bot">' +
          '<span class="typing-dot"></span><span class="typing-dot"></span><span class="typing-dot"></span>' +
        '</div>';
      messagesArea.appendChild(typing);
      messagesArea.scrollTop = messagesArea.scrollHeight;

      setTimeout(function () {
        if (typing.parentNode) typing.parentNode.removeChild(typing);
        var reply = getBotResponse(text);
        appendMessage('bot', reply);
      }, 800);
    }

    function getBotResponse(text) {
      var lower = text.toLowerCase().replace(/[^\w\s']/g, '');

      for (var i = 0; i < responses.length; i++) {
        if (responses[i].match(lower)) {
          return responses[i].reply;
        }
      }

      return FALLBACK_REPLY;
    }

    /* ----- Toggle Panel ----- */

    function openPanel() {
      panel.classList.add('is-open');
      if (!hasOpened) {
        hasOpened = true;
        appendMessage('bot', "Hey! \uD83D\uDC4B I\u2019m Nozl\u2019s virtual assistant. Ask me anything about our products, shipping, or returns.");
      }
      input.focus();
    }

    function closePanel() {
      panel.classList.remove('is-open');
    }

    on(toggleBtn, 'click', function () {
      if (panel.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    on(closeBtn, 'click', closePanel);

    /* ----- Send Message ----- */

    function sendMessage() {
      var text = input.value.trim();
      if (!text) return;
      appendMessage('user', text);
      input.value = '';
      showTypingThenReply(text);
    }

    if (chatForm) {
      on(chatForm, 'submit', function (e) {
        e.preventDefault();
        sendMessage();
      });
    }

    on(input, 'keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });
  }

  /* ========================================================================
   * 15. COOKIE BANNER
   * ======================================================================== */

  function initCookieBanner() {
    if (localStorage.getItem('nozl_cookie_consent')) return;

    var banner = qs('[data-cookie-banner]');
    if (!banner) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    });

    function dismiss(consent) {
      localStorage.setItem('nozl_cookie_consent', consent);
      banner.classList.remove('is-visible');
    }

    delegate(banner, 'click', '[data-cookie-accept]', function () {
      dismiss('accepted');
    });

    delegate(banner, 'click', '[data-cookie-decline]', function () {
      dismiss('declined');
    });
  }

  /* ========================================================================
   * 16. BACK TO TOP
   * ======================================================================== */

  function initBackToTop() {
    var btn = qs('[data-back-to-top]');
    if (!btn) return;

    function toggle() {
      if (window.scrollY > 500) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();

    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ========================================================================
   * 17. SMOOTH SCROLL
   * ======================================================================== */

  function initSmoothScroll() {
    delegate(document, 'click', 'a[href^="#"], a[href^="/#"]', function (e, link) {
      var href = link.getAttribute('href');
      if (!href || href === '#' || href === '#0') return;

      // Strip leading "/" so "/#section" becomes "#section"
      var hash = href.charAt(0) === '/' ? href.substring(1) : href;
      if (!hash || hash.charAt(0) !== '#') return;

      var target = qs(hash);
      if (!target) return;

      e.preventDefault();

      var header = qs('[data-header]');
      var headerOffset = header ? header.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top: top, behavior: 'smooth' });
      history.pushState(null, '', hash);
    });
  }

  /* ========================================================================
   * 18. ANNOUNCEMENT BAR OVERFLOW DETECTION
   * ======================================================================== */

  function initAnnouncementBar() {
    var bar = qs('[data-announcement-bar]');
    if (!bar) return;

    var content = qs('[data-announcement-text]', bar);
    if (!content) return;

    function checkOverflow() {
      if (content.scrollWidth > content.clientWidth) {
        bar.classList.add('announcement-bar--scrolling');
        if (!content.dataset.cloned) {
          var clone = content.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          content.parentNode.appendChild(clone);
          content.dataset.cloned = 'true';
        }
      } else {
        bar.classList.remove('announcement-bar--scrolling');
      }
    }

    checkOverflow();
    window.addEventListener('resize', debounce(checkOverflow, 250));
  }

  /* ========================================================================
   * INITIALIZATION
   * ======================================================================== */

  function init() {
    initScrollAnimations();
    initStickyHeader();
    initMobileMenu();
    initProductImageCarousel();
    initVariantSelector();
    initAjaxAddToCart();
    initQuantitySelector();
    initCartDrawer();
    initStickyAddToCartBar();
    initFaqAccordion();
    initProductTabs();
    initSocialProofTicker();
    initNewsletterForm();
    initChatWidget();
    initCookieBanner();
    initBackToTop();
    initSmoothScroll();
    initAnnouncementBar();
    initProductGallery();
    initPolicyModals();
    initCurrencySwitcher();
    updateCartCount();
  }

  /* ========================================================================
   * PRODUCT IMAGE GALLERY
   * ======================================================================== */

  function initProductGallery() {
    var galleries = qsa('[data-product-gallery]');
    galleries.forEach(function (gallery) {
      var slides = qsa('[data-gallery-slide]', gallery);
      var dots = qsa('[data-gallery-dot]', gallery);
      var prevBtn = qs('[data-gallery-prev]', gallery);
      var nextBtn = qs('[data-gallery-next]', gallery);
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      var current = 0;

      function goTo(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      if (prevBtn) on(prevBtn, 'click', function (e) { e.preventDefault(); goTo(current - 1); });
      if (nextBtn) on(nextBtn, 'click', function (e) { e.preventDefault(); goTo(current + 1); });

      dots.forEach(function (dot) {
        on(dot, 'click', function (e) {
          e.preventDefault();
          goTo(parseInt(dot.dataset.galleryDot, 10));
        });
      });

      // Swipe support
      var startX = 0;
      var viewport = qs('[data-gallery-viewport]', gallery);
      if (viewport) {
        on(viewport, 'touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        on(viewport, 'touchend', function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            goTo(diff > 0 ? current + 1 : current - 1);
          }
        });
      }
    });
  }

  /* ========================================================================
   * POLICY MODALS
   * ======================================================================== */

  function initPolicyModals() {
    delegate(document, 'click', '[data-open-policy]', function (e) {
      e.preventDefault();
      var policyName = this.dataset.openPolicy;
      var modal = qs('[data-policy-modal="' + policyName + '"]');
      if (modal) {
        modal.removeAttribute('hidden');
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
      }
    });

    delegate(document, 'click', '[data-policy-modal-close]', function (e) {
      e.preventDefault();
      var modal = this.closest('[data-policy-modal]');
      if (modal) {
        modal.classList.remove('is-open');
        setTimeout(function () { modal.setAttribute('hidden', ''); }, 300);
        if (!document.querySelector('.cart-drawer.is-open')) {
          document.body.style.overflow = '';
        }
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') {
        var openModal = qs('.policy-modal.is-open');
        if (openModal) {
          openModal.classList.remove('is-open');
          setTimeout(function () { openModal.setAttribute('hidden', ''); }, 300);
          document.body.style.overflow = '';
        }
      }
    });
  }

  /* ========================================================================
   * CURRENCY SWITCHER (GBP / AED) — COMPLETE REWRITE
   * ========================================================================
   * ARCHITECTURE:
   * - Shopify store base currency = AED
   * - Shopify Liquid {{ price | money }} outputs "Dhs. XX.XX" (AED)
   * - Shopify /cart.js returns prices in AED cents
   * - To get GBP: divide AED by 4.7
   * - To get AED from GBP: multiply GBP by 4.7
   * - Default display on page load = GBP
   * ======================================================================== */

  // Regex that matches any price format we use
  var PRICE_REGEX = /Dhs\.\s*[\d,]+\.?\d*|[\u00A3£][\d,]+\.?\d*/g;
  var PRICE_REGEX_SINGLE = /Dhs\.\s*[\d,]+\.?\d*|[\u00A3£][\d,]+\.?\d*/;

  /**
   * Extract numeric value from a price string
   * "Dhs. 63.65" → 63.65
   * "£13.54" → 13.54
   */
  function extractPriceNumber(str) {
    var cleaned = str.replace(/[^\d.,]/g, '').replace(',', '');
    return parseFloat(cleaned) || 0;
  }

  /**
   * Determine if a price string is in AED format
   */
  function isAedFormat(str) {
    return str.indexOf('Dhs') !== -1;
  }

  /**
   * Convert an AED amount to the target currency and format it
   */
  function formatAedAs(aedAmount, currency) {
    if (currency === 'GBP') {
      return '\u00A3' + (aedAmount / 4.7).toFixed(2);
    }
    return 'Dhs. ' + aedAmount.toFixed(2);
  }

  function initCurrencySwitcher() {
    var switcher = qs('[data-currency-switcher]');
    if (!switcher) return;

    var buttons = qsa('.currency-switcher__btn', switcher);

    // STEP 1: Tag every price element on page with its AED base value
    tagAllPriceElements();

    // STEP 2: Convert to GBP immediately (default display)
    if (currentCurrency === 'GBP') {
      convertAllPricesToCurrency('GBP');
    }

    // STEP 3: Handle currency button clicks
    buttons.forEach(function (btn) {
      on(btn, 'click', function () {
        var currency = btn.dataset.currency;
        if (currency === currentCurrency) return;
        currentCurrency = currency;
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        convertAllPricesToCurrency(currency);
      });
    });
  }

  /**
   * Find and tag every price element on the page.
   * Stores the AED base price in data-aed attribute.
   * Only processes elements that haven't been tagged yet.
   */
  function tagAllPriceElements() {
    // Known price selectors
    var knownSelectors = [
      '.homepage-product__price-amount',
      '[data-add-to-cart]',
      '.product-page__price',
      '.product-price',
      '.price',
      '.product-card__price'
    ];

    knownSelectors.forEach(function (sel) {
      qsa(sel).forEach(function (el) {
        tagSingleElement(el);
      });
    });

    // Also scan for any text node containing Dhs. or £ pattern
    var allElements = document.querySelectorAll('span, p, div, button, a, h1, h2, h3, h4, h5, h6, strong, em, label, td, th, li');
    for (var i = 0; i < allElements.length; i++) {
      var el = allElements[i];
      if (el.dataset.aed) continue; // already tagged
      var tag = el.tagName.toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'svg') continue;

      // Only process leaf-level text (no child elements with prices)
      var text = el.textContent.trim();
      if (!PRICE_REGEX_SINGLE.test(text)) continue;

      // Check that this element's own direct text has the price (not just child elements)
      var directText = '';
      for (var j = 0; j < el.childNodes.length; j++) {
        if (el.childNodes[j].nodeType === 3) {
          directText += el.childNodes[j].textContent;
        }
      }
      if (PRICE_REGEX_SINGLE.test(directText)) {
        tagSingleElement(el);
      }
    }
  }

  /**
   * Tag a single element with its AED base price.
   * On first load, Shopify renders everything in AED (Dhs. format).
   * If we see a £ value, it means we already converted it — reverse to get AED.
   */
  function tagSingleElement(el) {
    if (el.dataset.aed) return; // already tagged

    var text = el.textContent.trim();
    var match = text.match(PRICE_REGEX_SINGLE);
    if (!match) return;

    var priceStr = match[0];
    var numericVal = extractPriceNumber(priceStr);
    if (numericVal <= 0) return;

    var aedVal;
    if (isAedFormat(priceStr)) {
      // Already in AED — apply correction multiplier (admin prices are 100x too low)
      aedVal = numericVal * PRICE_CORRECTION_MULTIPLIER;
    } else {
      // Currently showing GBP (£) — convert back to AED: GBP × 4.7 = AED
      // Also apply correction multiplier
      aedVal = numericVal * 4.7 * PRICE_CORRECTION_MULTIPLIER;
    }

    el.dataset.aed = aedVal.toFixed(2);
  }

  /**
   * Convert ALL tagged price elements to the specified currency.
   * Also handles Add to Cart buttons and variant pills specially.
   */
  var isConverting = false; // guard against MutationObserver re-entry

  function convertAllPricesToCurrency(currency) {
    if (isConverting) return;
    isConverting = true;

    // Re-tag any new elements that appeared since last time
    tagAllPriceElements();

    // Convert all tagged elements
    var tagged = qsa('[data-aed]');
    tagged.forEach(function (el) {
      var aedVal = parseFloat(el.dataset.aed);
      if (isNaN(aedVal) || aedVal <= 0) return;

      var formatted = formatAedAs(aedVal, currency);

      // Skip variant pills — they display names, not prices.
      // Their price data is stored in data-variant-price attribute only.
      if (el.classList.contains('variant-pill')) return;

      // Check if this is the Add to Cart button
      if (el.hasAttribute('data-add-to-cart')) {
        el.textContent = 'Add to Cart \u2014 ' + formatted;
        return;
      }

      // For simple text-only elements, just replace the price pattern
      if (el.children.length === 0) {
        var currentText = el.textContent;
        if (PRICE_REGEX_SINGLE.test(currentText)) {
          el.textContent = currentText.replace(PRICE_REGEX_SINGLE, formatted);
        } else {
          // Only set if this looks like a dedicated price element
          if (el.classList.contains('homepage-product__price-amount') ||
              el.classList.contains('product-price') ||
              el.classList.contains('price') ||
              el.classList.contains('cart-drawer__item-price') ||
              el.classList.contains('cart-drawer__total-amount') ||
              el.classList.contains('product-page__price') ||
              el.classList.contains('product-card__price')) {
            el.textContent = formatted;
          }
        }
      } else {
        // Element has children — find and replace in text nodes only
        for (var i = 0; i < el.childNodes.length; i++) {
          if (el.childNodes[i].nodeType === 3 && PRICE_REGEX_SINGLE.test(el.childNodes[i].textContent)) {
            el.childNodes[i].textContent = el.childNodes[i].textContent.replace(PRICE_REGEX_SINGLE, formatted);
          }
        }
      }
    });

    // Update variant pill data attributes (NOT their visible text)
    qsa('.variant-pill').forEach(function (pill) {
      if (pill.dataset.aed) {
        var aed = parseFloat(pill.dataset.aed);
        if (!isNaN(aed)) {
          pill.dataset.variantPrice = formatAedAs(aed, currency);
        }
      }
    });

    isConverting = false;

    // Update cart drawer prices (these are rendered dynamically)
    var drawerPrices = qsa('.cart-drawer__item-price, .cart-drawer__total-amount');
    drawerPrices.forEach(function (el) {
      if (el.dataset.aed) {
        var aed = parseFloat(el.dataset.aed);
        if (!isNaN(aed)) {
          el.textContent = formatAedAs(aed, currency);
        }
      }
    });
  }

  // Observe DOM for dynamically added price elements (cart drawer opening, etc.)
  function observePriceChanges() {
    if (typeof MutationObserver === 'undefined') return;
    var convertTimer = null;
    var observer = new MutationObserver(function (mutations) {
      // Don't fire while we're already converting (prevents infinite loops)
      if (isConverting) return;
      var needsUpdate = false;
      mutations.forEach(function (m) {
        if (m.addedNodes.length > 0) needsUpdate = true;
      });
      if (needsUpdate) {
        clearTimeout(convertTimer);
        convertTimer = setTimeout(function () {
          convertAllPricesToCurrency(currentCurrency);
        }, 200);
      }
    });
    // Only observe the cart drawer for dynamic content, not the whole body
    var drawer = qs('[data-cart-drawer]');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  // Call observer setup after init
  setTimeout(observePriceChanges, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
